<script>

import Textbox from '@/components/Textbox'
import Btn from '@/components/Btn'
import LoginRegisterSwitcher from '@/components/LoginRegisterSwitcher'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'Register',
  components: {
    Textbox,
    Btn,
    LoginRegisterSwitcher
  },
  props: {
    status: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      login: '',
      email: '',
      phone: '',
      organization: '',
      password: '',
      password_repeat: '',
      registered: this.status === 'ready',
      loading: true,
      recaptcha_url: 'https://www.google.com/recaptcha/api.js?render=',
      recaptcha_public: '',
      login_busy: false
    }
  },
  validations: {
    login: {
      required,
      login (value) {
        return /^[0-9A-Za-z_.]+$/.test(value)
      },
      busy () {
        return !this.login_busy
      }
    },
    email: {
      required,
      email
    },
    phone: {
      required,
      phone (value) {
        return /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*$/.test(value)
      }
    },
    password: {
      required,
      password (value) {
        return /^.{6,}$/.test(value)
      }
    },
    password_repeat: {
      equal (value) {
        return value === this.password
      }
    },
    organization: {
      required
    },
    empty: {}
  },
  computed: {
    className () {
      return this.$v.$error ? 'shake animated' : ''
    },
    flipperClassName () {
      return this.registered ? 'rotate' : ''
    },
    isRecaptchaScriptLoaded () {
      let scripts = document.getElementsByTagName('script')
      for (var i = scripts.length; i--;) {
        if (scripts[i].src === this.recaptcha_url + this.recaptcha_public) return true
      }
      return false
    },
    privacyPolicyLink () {
      return this.$i18n.locale === 'en' ? 'http://s.platformcraft.ru/privacy_policy.pdf' : 'http://s.platformcraft.ru/privacy_policy_ru.pdf'
    }
  },
  created () {

  },
  mounted () {
    if (!this.recaptcha_public) {
      this.$api.recaptcha({ domain: window.location.host }).then(({ data }) => {
        this.recaptcha_public = data
        this.loadRecaptchaScript()
        this.loading = false
      })
    }
  },
  methods: {
    register () {
      if (!this.$v.$invalid) {
        this.loading = true
        window.grecaptcha.execute(this.recaptcha_public, { action: 'login' }).then((token) => {
          this.$api.register({
            username: this.login,
            email: this.email,
            phone: this.phone,
            organization: this.organization,
            password: this.password,
            language: this.$i18n.locale,
            domain: window.location.host,
            tz_offset: -(new Date().getTimezoneOffset()),
            'g-recaptcha-response': token
          }).then((response) => {
            this.loading = false
            this.registered = true
          }).catch((error) => {
            let text = 'Ошибка сервера.'
            if (error.response.status === 409) {
              this.login_busy = true
              text = 'Указанный логин занят. Пожалуйста, выберете другой.'
            }
            if (error.response.status === 403) {
              text = 'Регистрация запрещена.'
            }
            this.$toast.show({
              text: this.$t(text)
            })
            this.loading = false
          })
        })
      }
    },
    loadRecaptchaScript () {
      if (!this.isRecaptchaScriptLoaded) {
        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', this.recaptcha_url + this.recaptcha_public)
        recaptchaScript.async = true
        recaptchaScript.defer = true
        document.head.appendChild(recaptchaScript)
      }
    },
    onChangeLogin () {
      this.login_busy = false
    }
  }
}

</script>

<template lang="pug">

.wrapper.flip-wrapper
  .register.flipper(:class="flipperClassName")
    .flip-front(:class="className")
      .form(@keyup.enter="register")
        login-register-switcher.margin-bottom-4x
        .margin-bottom-2x
          .inline-block.margin-bottom.text-uppercase {{ $t('Логин') }}
          textbox(v-model="login", @input="onChangeLogin", :validator="$v.login", name="login")
          .has-error(v-if="$v.login.$error&&!$v.login.login") {{ $t('Логин может содержать только буквы, цифры, "_" и ".".') }}
          .has-error(v-if="$v.login.$error&&!$v.login.busy") {{ $t('Указанный логин занят. Пожалуйста, выберете другой.') }}
        .margin-bottom-2x
          .inline-block.margin-bottom.text-uppercase E-mail
          textbox(v-model="email", :validator="$v.email", name="email")
          .has-error(v-if="$v.email.$error") {{ $t('Введите валидный email.') }}
        .margin-bottom-2x
          .inline-block.margin-bottom.text-uppercase {{ $t('Телефон') }}
          textbox(v-model="phone", :validator="$v.phone", name="phone")
          .has-error(v-if="$v.phone.$error") {{ $t('Неправильный формат телефона.') }}
        .margin-bottom-2x
          .inline-block.margin-bottom.text-uppercase {{ $t('Название организации') }}
          textbox(v-model="organization", :validator="$v.organization", name="organization")
          .has-error(v-if="$v.organization.$error") {{ $t('Обязательное поле.') }}
        .margin-bottom-2x
          .inline-block.margin-bottom.text-uppercase {{ $t('Пароль') }}
          textbox(v-model="password", type="password", :validator="$v.password", name="password")
          .has-error(v-if="$v.password.$error") {{ $t('Пароль должен содержать не менее 6 символов.') }}
        .margin-bottom-2x
          .inline-block.margin-bottom.text-uppercase {{ $t('Повторите пароль') }}
          textbox(v-model="password_repeat", type="password", :validator="$v.password_repeat", name="password_repeat")
          .has-error(v-if="$v.password_repeat.$error") {{ $t('Пароли не совпадают.') }}
        .margin-bottom-2x.center {{ $t('Регистрируясь в сервисе Platformcraft, вы соглашаетесь с политикой использования') }} <a target="_blank" :href="privacyPolicyLink">{{ $t('персональных данных') }} </a>
        .text-right
          btn(@click="register", :disabled="$v.$invalid || loading") {{ $t('Создать') }}
    .flip-back
      .form
        .rocket-ship
        .line
        .text-uppercase.text-big.text-center.margin-bottom {{ $t('Почти готово!') }}
        .text-light
          .margin-bottom-2x {{ $t('На указанный Вами e-mail адрес выслано письмо с инструкциями по дальнейшей настройке Вашего аккаунта.') }}

</template>

<style scoped lang="sass">

.wrapper
  padding-top: 100px

.register
  width: 350px
  margin: auto

.form
  padding: 25px 20px
  background: #FFFFFF

.line
  height: 1px
  background: #ECECEC
  width: 185px
  margin: 0 auto $vertical-step auto

.center
  text-align: center

.rocket-ship
  width: 64px
  height: 64px
  margin: 10px auto 18px
  background: url('~@/assets/rocket-ship.png') no-repeat

</style>
